module.exports = __webpack_public_path__ + "static/media/union.54432691.svg";